// extracted by mini-css-extract-plugin
export default {"header":"styles_header__NyX8e","logo":"styles_logo__hTa5C","user-name":"styles_user-name__hQQeD","divider":"styles_divider__SIjF6"};